import { render, staticRenderFns } from "./stockoutChanges_review.vue?vue&type=template&id=7790b709&scoped=true&"
import script from "./stockoutChanges_review.vue?vue&type=script&lang=js&"
export * from "./stockoutChanges_review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7790b709",
  null
  
)

export default component.exports